module.exports = __webpack_public_path__ + "static/media/Pedders_logo.69ddba70.jpg";